// ------------ Constant Variable for Form Validation ----------//
export const MINIMUM_RESULT_SCORE = 'minimumResultScore'
export const NUMBER_OF_WASHES = 'numberOfWashes'
export const REFRESH_TIME = 'refreshTime'